/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import { ReactComponent as IconChevronDown } from '../../../../../assets/images/icons/config n detected down arrow.svg';
// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// ==============================|| SIDEBAR MENU LIST COLLAPSE ITEMS ||============================== //

const NavCollapse = ({ menu, level }) => {
    const theme = useTheme();
    // console.log('menu in navcollapse',menu);
    // const customization = useSelector((state) => state.customization);
    let navigate = useNavigate(); //for navigation

    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);

    const handleClick = () => {
        setOpen(!open);
        if (!selected || selected !== menu.id) {
            setSelected(menu.id);
        } else {
            setSelected(null);
        }
        if (menu?.id !== 'authentication') {
            // navigate( menu?.children[ 0 ]?.url );
            navigate(menu?.url);
        }
    };

    const { pathname } = useLocation();
    const checkOpenForParent = (child, id) => {
        child.forEach((item) => {
            if (item.url === pathname) {
                setOpen(true);
                setSelected(id);
            }
        });
    };

    // menu collapse for sub-levels
    useEffect(() => {
        setOpen(false);
        setSelected(null);
        if (menu.children) {
            menu.children.forEach((item) => {
                if (item.children?.length) {
                    checkOpenForParent(item.children, menu.id);
                }
                if (item.url === pathname) {
                    setSelected(menu.id);
                    setOpen(true);
                }
            });
        }
    }, [pathname, menu.children]);

    // menu collapse & item
    const menus = menu.children?.map((item) => {
        switch (item.type) {
            case 'collapse':
                return <NavCollapse key={item.id} menu={item} level={level + 1} />;
            case 'item':
                return <NavItem key={item.id} item={item} level={level + 1} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });
    const SIcon = menu.selected_icon;
    const SelectedIcon = menu.selected_icon ? (
        <SIcon strokeWidth={1.5} size="1.3rem" style={{ marginTop: 'auto', marginBottom: 'auto', width: '22px', height: '22px' }} />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: selected === menu.id ? 8 : 6,
                height: selected === menu.id ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    const Icon = menu.icon;
    const menuIcon = menu.icon ? (
        <Icon strokeWidth={1.5} size="1.3rem" style={{ marginTop: 'auto', marginBottom: 'auto', width: '22px', height: '22px' }} />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: selected === menu.id ? 8 : 6,
                height: selected === menu.id ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    return (
        <>
            <ListItemButton
                sx={{
                    width: '240px',
                    height: '40px',
                    padding: '10px 15px',
                    gap: '10px',
                    borderRadius: '5px',
                    mb: 0.5,
                    marginBottom: '10px',
                    // alignItems: 'flex-start',
                    alignItems: 'center',
                    backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                    py: level > 1 ? 1 : 1.25,
                    pl: `${level * 24}px`
                }}
                selected={selected === menu.id}
                onClick={handleClick}
            >
                <ListItemIcon sx={{ my: 'auto', minWidth: !menu.icon ? 18 : 22 }}>
                    {selected === menu.id ? SelectedIcon : menuIcon}
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography
                            // variant={selected === menu.id ? 'h5' : 'body1'}
                            // color="inherit"
                            sx={{
                                display: 'flex',
                                height: '19px',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                flex: '1 0 0',
                                // fontWeight: selected === menu.id ? 700 : 400,
                                // color: 'var(--primary, #03045E)',
                                // fontFamily: 'Open Sans',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                lineHeight: 'normal',
                                my: 'auto'
                            }}
                            className={selected === menu.id ? 'OpenSansBold' : 'OpenSansRegular'}
                        >
                            {menu?.title}
                        </Typography>
                    }
                    secondary={
                        menu?.caption && (
                            <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                {menu?.caption}
                            </Typography>
                        )
                    }
                />
                <IconChevronDown
                    stroke={1.5}
                    size="1rem"
                    style={{
                        marginTop: '-4px',
                        marginBottom: 'auto',
                        width: '30px',
                        height: '30px',
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)', // Rotate based on `open` state
                        /* stylelint-disable-next-line order/properties-order */
                        transition: 'transform 0.3s ease' // Smooth transition
                    }}
                />

                {/* {open ? (
                    <IconChevronDown
                        stroke={1.5}
                        size="1rem"
                        style={{ marginTop: '-4px', marginBottom: 'auto', width: '30px', height: '30px' }}
                    />
                ) : (
                    // <IconChevronUp
                    //     stroke={1.5}
                    //     size="1rem"
                    //     style={{ marginTop: '-4px', marginBottom: 'auto', width: '30px', height: '30px' }}
                    // />
                    <IconChevronDown
                        stroke={1.5}
                        size="1rem"
                        style={{ marginTop: '-4px', marginBottom: 'auto', width: '30px', height: '30px' }}
                    />
                )} */}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                    component="div"
                    disablePadding
                    sx={{
                        position: 'relative',
                        '&:after': {
                            content: "''",
                            position: 'absolute',
                            left: '32px',
                            top: 0,
                            height: '100%',
                            width: '1px',
                            opacity: 1
                            // background: theme.palette.primary.light
                        }
                    }}
                >
                    {menus}
                </List>
            </Collapse>
        </>
    );
};

NavCollapse.propTypes = {
    menu: PropTypes.object,
    level: PropTypes.number
};

export default NavCollapse;
